import createIcon from '../../createIcon';

/**
 * @component @name PhoneForwarded
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTJMMjIgN0wxNyAyVjVIMTNWOUgxN1YxMlpNMTkgMTYuNUMxNy43NSAxNi41IDE2LjU1IDE2LjMgMTUuNDMgMTUuOTNDMTUuMDggMTUuODIgMTQuNjkgMTUuOSAxNC40MSAxNi4xN0wxMi4yMSAxOC4zN0M5LjM4IDE2LjkzIDcuMDYgMTQuNjIgNS42MiAxMS43OEw3LjgyIDkuNTdDOC4xIDkuMzEgOC4xOCA4LjkyIDguMDcgOC41N0M3LjcgNy40NSA3LjUgNi4yNSA3LjUgNUM3LjUgNC40NSA3LjA1IDQgNi41IDRIM0MyLjQ1IDQgMiA0LjQ1IDIgNUMyIDE0LjM5IDkuNjEgMjIgMTkgMjJDMTkuNTUgMjIgMjAgMjEuNTUgMjAgMjFWMTcuNUMyMCAxNi45NSAxOS41NSAxNi41IDE5IDE2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneForwarded = createIcon('PhoneForwarded', [
  [
    'path',
    {
      d: 'M17 12L22 7L17 2V5H13V9H17V12ZM19 16.5C17.75 16.5 16.55 16.3 15.43 15.93C15.08 15.82 14.69 15.9 14.41 16.17L12.21 18.37C9.38 16.93 7.06 14.62 5.62 11.78L7.82 9.57C8.1 9.31 8.18 8.92 8.07 8.57C7.7 7.45 7.5 6.25 7.5 5C7.5 4.45 7.05 4 6.5 4H3C2.45 4 2 4.45 2 5C2 14.39 9.61 22 19 22C19.55 22 20 21.55 20 21V17.5C20 16.95 19.55 16.5 19 16.5Z',
      key: 'r8i1hb',
    },
  ],
]);

export default PhoneForwarded;
